<template>
  <div class="container">
    <!-- 进度条 -->
    <scroll :scrollX="true" :pullup="false" :scrollY="false" :mainWidth="progressBoxWidth" :startX="(data.status==5||data.status == 10 || data.status == 8 || data.status == 9)?-progressItemWidth*3:0" :pulldown="false" class="scroll_box">
      <section class="progress_box">
      <section class="progress_item" ref="progressItem">
        <img :src="require(`../../assets/images/icon_check_${common.theme}.png`)" />
        <p class="status_cur">已预约</p>
        <p class="data">{{data.createTime | timeYmd}} {{data.createTime | timeHmm}}</p>
        <!-- <p class="data">{{data.createTime | timeHmm}}</p> -->
        <span :class="['line',data.updateTime?'line_color':'']"></span>
      </section>
      <section class="progress_item">
        <span class="default_item" v-if="data.status == 6 || data.status == 1"></span>
        <img v-else :src="require(`../../assets/images/icon_check_${common.theme}.png`)" />
        <p class="status_cur">已受理</p>
        <p class="data" v-if="data.status == 7 && data.updateTime">{{data.updateTime | timeYmd}} {{data.updateTime | timeHmm}}</p>
        <span :class="['line',data.updateTime && (data.status == 3 || data.status == 2 || data.status == 4 || data.status == 5 || data.status == 0 || data.status == 8 ||data.status == 9||data.status == 10)?'line_color':'']"></span>
      </section>
      <section class="progress_item">
        <span class="default_item" v-if="data.status == 6 || data.status == 7 || data.status == 1"></span>
        <img v-else :src="require(`../../assets/images/icon_check_${common.theme}.png`)" />
        <p class="status_cur">确认费用</p>
        <p class="data" v-if="data.status == 0 && data.updateTime">{{data.updateTime | timeYmd}} {{data.updateTime | timeHmm}}</p>
        <!-- <p class="data" v-if="data.status == 0 && data.updateTime">{{data.updateTime | timeHmm}}</p> -->
        <span :class="['line',(data.status == 2 || data.status == 5 || data.status == 8 ||data.status == 9||data.status == 10)?'line_color':'']"></span>
      </section>
      <section class="progress_item">
        <span class="default_item" v-if="!(data.status == 2 || data.status == 5 || data.status == 8 ||data.status == 9||data.status == 10)"></span>
        <img v-else :src="require(`../../assets/images/icon_check_${common.theme}.png`)" />
        <p class="status_cur">已支付</p>
        <p class="data" v-if="data.status == 2 && data.updateTime">{{data.updateTime | timeYmd}} {{data.updateTime | timeHmm}}</p>
        <!-- <p class="data" v-if="data.status == 2 && data.updateTime">{{data.updateTime | timeHmm}}</p> -->
        <span :class="['line',(data.status == 5 || data.status == 8 ||data.status == 9||data.status == 10)?'line_color':'']"></span>
      </section>
      <!-- 待服务 -->
      <section class="progress_item">
        <span class="default_item" v-if="!(data.status == 5 || data.status == 8 ||data.status == 9||data.status == 10)"></span>
        <img v-else :src="require(`../../assets/images/icon_check_${common.theme}.png`)" />
        <p class="status_cur">待服务</p>
         <p class="data" v-if="data.status == 9 && data.updateTime">{{data.updateTime | timeYmd}} {{data.updateTime | timeHmm}}</p>
        <span :class="['line',(data.status == 5 || data.status == 8||data.status == 10)?'line_color':'']"></span>
      </section>
      <!-- 已服务 -->
      <section class="progress_item">
        <span class="default_item" v-if="!(data.status == 5 || data.status == 8 ||data.status == 10)"></span>
        <img v-else :src="require(`../../assets/images/icon_check_${common.theme}.png`)" />
        <p class="status_cur">已服务</p>
        <p class="data" v-if="data.status == 10 && data.updateTime">{{data.updateTime | timeYmd}} {{data.updateTime | timeHmm}}</p>
        <span :class="['line',(data.status == 5 || data.status == 8)?'line_color':'']"></span>
      </section>
      <section class="progress_item">
        <span class="default_item" v-if="!(data.status == 5 || data.status == 8)"></span>
        <img v-else :src="require(`../../assets/images/icon_check_${common.theme}.png`)" />
        <p class="status_cur">已完成</p>
        <p class="data" v-if="data.status == 5 && data.updateTime">{{data.updateTime | timeYmd}} {{data.updateTime | timeHmm}}</p>
        <!-- <p class="data" v-if="data.status == 5 && data.updateTime">{{data.updateTime | timeHmm}}</p> -->
        <span :class="['line',data.status == 8?'line_color':'']"></span>
      </section>
      <section class="progress_item">
        <span class="default_item" v-if="data.status != 8"></span>
        <img v-else :src="require(`../../assets/images/icon_check_${common.theme}.png`)" />
        <p class="status_cur">已评价</p>
        <p class="data" v-if="data.status == 8 && data.updateTime">{{data.updateTime | timeYmd}} {{data.updateTime | timeHmm}}</p>
        <!-- <p class="data" v-if="data.status == 8 && data.updateTime">{{data.updateTime | timeHmm}}</p> -->
        <span class="line"></span>
      </section>
      <section class="progress_item" v-if="data.status == 1">
        <img :src="require(`../../assets/images/icon_check_${common.theme}.png`)" />
        <p class="status_cur">已取消</p>
        <p class="data" v-if="data.updateTime">{{data.updateTime | timeYmd}} {{data.updateTime | timeHmm}}</p>
        <!-- <p class="data" v-if="data.updateTime">{{data.updateTime | timeHmm}}</p> -->
      </section>
      </section>
    </scroll>
    <!-- 预约详情 -->
    <section class="common_module">
      <h2>预约详情</h2>
      <ul>
        <li v-if="data.createTime">
          <p class="list_left">提交时间</p>
          <p class="list_right">{{data.createTime | timeT}}</p>
        </li>
        <li v-if="data.orderTime">
          <p class="list_left">预约时间</p>
          <p class="list_right">{{data.orderTime}}</p>
        </li>
        <li v-if="data.companyName">
          <p class="list_left">企业信息</p>
          <p class="list_right">{{data.companyName}}</p>
        </li>
        <li v-if="data.roomName">
          <p class="list_left">单元名称</p>
          <p class="list_right">{{data.roomName}}</p>
        </li>
        <li v-if="data.roomNo">
          <p class="list_left">单元号</p>
          <p class="list_right">{{data.roomNo}}</p>
        </li>
        <li>
          <p class="list_left">预约人</p>
          <p class="list_right">
            {{data.userName}}
            <a :href="'tel:'+data.phone" :phone="data.phone">{{data.phone}}</a>
          </p>
        </li>
        <li v-if="data.remark">
          <p class="list_left">备注</p>
          <p class="list_right">{{data.remark}}</p>
        </li>
      </ul>
    </section>
    <!-- 服务人员已评估  && come != 'manage'-->
    <section class="common_module" v-if="data.status == 7 ">
      <h2 v-if="data.status == 7">待主管上门评估</h2>
      <ul>
        <li>
          <p class="list_left">主管</p>
          <p class="list_right">
            {{intservWorker.name}}
            <a :href="'tel:'+intservWorker.phone" :phone="intservWorker.phone">{{intservWorker.phone}}</a>
          </p>
        </li>
      </ul>
    </section>
    <section class="common_module" v-if="data.status != 6 && data.status != 7 && data.status != 1">
      <h2>主管已评估</h2>
      <ul>
        <li>
          <p class="list_left">主管</p>
          <p class="list_right">
            {{intservWorker.name}}
            <a :href="'tel:'+intservWorker.phone" :phone="intservWorker.phone">{{intservWorker.phone}}</a>
          </p>
        </li>
        <li v-if="curImgs.length > 0">
          <p class="list_left">现场照片</p>
          <section class="imgs">
            <img @click="viewBigPic(item.imgUrl,1)" v-for="item in curImgs" :key="item.id" :src="item.imgUrl"  />
          </section>
        </li>
        <li v-if="sureImgs.length > 0">
          <p class="list_left">完成确认</p>
          <section class="imgs">
            <img @click="viewBigPic(item.imgUrl,2)" v-for="item in sureImgs" :key="item.id" :src="item.imgUrl"  />
          </section>
        </li>
        <!-- <li>
          <p class="list_left">备注</p>
          <p class="list_right">备注内容备注内容备注内容备注内容备注内容备注内容备注内容备注内容</p>
        </li> -->
      </ul>
      <h2  v-if="data.status ==5 || data.status == 8 || data.status == 9 || data.status == 10" >服务人员提供服务</h2>
      <ul v-if="data.status ==5 || data.status == 8 || data.status == 9|| data.status == 10">
        <li>
          <p class="list_left">服务人员</p>
          <p class="list_right">
            {{intservServer.name}}
            <a :href="'tel:'+intservServer.phone" :phone="intservServer.phone">{{intservServer.phone}}</a>
          </p>
        </li>
      </ul>
    </section>
    <!-- 收费 -->
    <section class="cost_box" v-if="data.totalPrice">
      <span class="span_left">收费</span>
      <!-- <span class="desc">(实际收费根据服务人员上门评估为准)</span> -->
      <span class="price">¥{{data.totalPrice}}</span>
      <span v-if="come=='manage' && data.status == 0 && data.payType != 6" class="change_price" @click="costEvaluate('changePrice')">改价</span>
    </section>
    <!-- 改价记录 -->
    <section class="changePrice_box" v-if="intservPriceItems.length > 0">
      <h3>改价记录</h3>
      <section class="change_item" v-for="item in intservPriceItems" :key="item.createTime">
        <section class="change_item_top">
          <p>{{item.createTime | timeT}}</p>
          <p>原价:¥{{item.prevAmount|priceFormat}}</p>
        </section>
        <section class="change_item_bottom">
          <p>修改人: {{item.createUser}}</p>
          <p class="right_price">修改为:¥{{item.currAmount|priceFormat}}</p>
        </section>
      </section>
    </section>
    <!-- 查看大图 -->
    <fade-animation>
      <common-gallary :imgs="imgs" :curIndex="curIndex" v-show="showGallary" @close="handleGallaryClose"></common-gallary>
    </fade-animation>
    <section class="footer_h"></section>
    <!-- 状态为已预约 -->
    <template v-if="data.status == 6">
      <!-- 来源不是企业微信 -->
      <common-footer class="footer_box button" v-if="!come">
        <mt-button class="btn btn_left btn_primary" @click="cancel">取消预约</mt-button>
        <mt-button class="btn btn_unclick">立即支付</mt-button>
      </common-footer>
      <!-- 来源是企业微信-管理员 -->
      <common-footer class="footer_box button" v-if="come == 'admin'">
        <mt-button class="btn btn_left btn_primary" @click="cancel">撤销预约</mt-button>
        <mt-button class="btn btn_right btn_default" @click="dispatch(2)">派单给主管</mt-button>
      </common-footer>
    </template>
    <!-- 已派单 -->
    <template v-else-if="data.status == 7">
      <!-- 来源不是企业微信 -->
      <common-footer class="footer_box button" v-if="!come">
        <mt-button class="btn btn_left btn_primary" @click="cancel">取消预约</mt-button>
        <mt-button class="btn btn_unclick">立即支付</mt-button>
      </common-footer>
      <!-- 来源是企业微信 -->
      <common-footer class="footer_box button" v-if="come == 'manage'">
        <mt-button class="btn btn_right btn_w btn_default" @click="costEvaluate">现场确认费用</mt-button>
      </common-footer>
    </template>
    <!-- 状态为待支付 status == 0 或者已超时-->
    <template v-else-if="data.status == 0 || data.status == 3">
      <common-footer class="footer_box button" v-if="!come && (data.payType != 6 || data.status == 3)">
        <mt-button class="btn btn_left btn_primary" @click="cancel">取消预约</mt-button>
        <mt-button class="btn btn_left btn_primary" @click="offlinePay">线下支付</mt-button>
        <mt-button class="btn btn_default" @click="pay">线上支付</mt-button>
      </common-footer>
      <section class="wait_cost" v-if="!come && data.payType == 6 && data.status != 3">
        <p>待线下确认</p>
        <p class="desc">请在下单后15分钟内完成支付</p>
      </section>
      <common-footer class="footer_box button" v-else-if="come == 'manage' && data.payType == 6 && data.status != 3">
        <mt-button class="btn btn_right btn_w btn_default" @click="surePay">确认已支付</mt-button>
      </common-footer>
    </template>
    <!-- 已支付 -->
    <template v-else-if="data.status == 2">
      <!-- <common-footer class="footer_box button" v-if="come == 'staff'">
        <mt-button class="btn btn_right btn_w btn_default" @click="serviceC">服务完成</mt-button>
      </common-footer> -->
      <common-footer class="footer_box button" v-if="come == 'manage'">
        <mt-button class="btn btn_right btn_w btn_default" @click="dispatch(1)">指派服务人员</mt-button>
      </common-footer>
    </template>
    <template v-else-if="data.status == 9">
      <common-footer class="footer_box button" v-if="come == 'staff'">
        <mt-button class="btn btn_right btn_w btn_default" @click="serviceC">服务完成</mt-button>
      </common-footer>
    </template>
    <template v-else-if="data.status == 10">
      <common-footer class="footer_box button" v-if="!come">
        <mt-button class="btn btn_right btn_w btn_default" @click="serviceC">服务完成</mt-button>
      </common-footer>
    </template>
    <!-- 已完成 -->
    <template v-else-if="data.status == 5">
      <common-footer class="footer_box button" v-if="!come && hasEvaluateTemplate">
        <mt-button class="btn btn_right btn_w btn_default" @click="toEvaluate">去评价</mt-button>
      </common-footer>
    </template>
    <!-- 已评价 -->
    <template v-else-if="data.status == 8">
      <common-footer class="footer_box button">
        <mt-button class="btn btn_right btn_w btn_default" @click="viewEvaluate">查看评价</mt-button>
      </common-footer>
    </template>
  </div>
</template>

<script>
import util from "../../utils/util";
import { getIntServOrderByOrderId, updateIntServOrder } from "../../utils/api";
import commonFooter from "../../components/commonFooter";
import { mapState } from "vuex";
import ping from "../../utils/pingpay.js";
import CommonGallary from "../../components/Gallary";
import FadeAnimation from "../../components/FadeAnimation";
import Scroll from '../../components/scroll';
let timer = '';
export default {
  name: "myAppointDetail",
  components: {
    commonFooter,
    CommonGallary,
    FadeAnimation,
    Scroll
  },
  data() {
    return {
      pageNo: 1,
      type: 0,
      allLoaded: false,
      loaded: false,
      data:{},
      dataList: [],
      updateTime:'',
      intservWorker:{}, //主管
      intservServer:{}, // 服务人员
      serviceType:'',
      progressBoxWidth:'',
      progressItemWidth:'',
      showGallary:false,
      imgs:[],
      curImgs:[],
      sureImgs:[],
      endPicRequired:-1,//0 非必填图片, 1必填
      curIndex:0,
      hasEvaluateTemplate:true,
      come:'',  // admin 管理员  staff 服务人员   manage //主管
      prePrice:'',//改价前的价格
      intservPriceItems:[]//改价数据
    };
  },
  filters: {
    timeT(val){
      return util.formatTime(new Date(Number(val)), 10);
    },
    timeYmd(val) {
      return util.formatTime(new Date(Number(val)), 24);
    },
    timeHmm(val) {
      return util.formatTime(new Date(Number(val)), 22);
    },
    statusText(val) {
      // 0待支付，1已取消，2已支付，3已超时，4已退款，5已完成  6待受理 7已派单 8已评价,10已服务
      let text = "";
      switch (val) {
        case "0":
          text = "确认费用";
          break;
        case "1":
          text = "已取消";
          break;
        case "2":
          text = "已支付";
          break;
        case "3":
          text = "已超时";
          break;
        case "4":
          text = "已退款";
          break;
        case "5":
          text = "已完成";
          break;
        case "6":
          text = "已预约";
          break;
        case "7":
          text = "已受理";
          break;
        case "8":
          text = "已评价";
          break;
        case "9":
          text = "已服务";
          break;
        default:
          text = "已预约";
      }
      return text;
    }
  },
  computed: {
    ...mapState({
      common: state => state.common
    })
  },
  activated() {
    this.come = this.$route.query.come || '';
    this.progressBoxWidth = this.$refs.progressItem.clientWidth*8+'px';
    this.progressItemWidth = this.$refs.progressItem.clientWidth;
    util.showLoading()
    this.getIntServOrderByOrderId()
  },
  destroyed() {
    clearTimeout(timer);
  },
  methods: {
    handleGallaryClose() {
      this.showGallary = false;
    },
    viewBigPic(imgPath,type) {
      if(type == 1){
        let newA = []
       this.curImgs.forEach((item,index) => {
        newA.push(item.imgUrl)
        if(item.imgUrl == imgPath){
          this.curIndex = index
          this.showGallary = true
        }
       });
       this.imgs = newA
      }else{
        let newA = []
        this.sureImgs.forEach((item,index) => {
          newA.push(item.imgUrl)
          if(item.imgUrl == imgPath){
            this.curIndex = index
            this.showGallary = true
          }
        });
       this.imgs = newA
      }
    },
    getIntServOrderByOrderId(){
      getIntServOrderByOrderId({orderId:this.$route.query.id}).then(res=>{
        console.log(res)
        util.hideLoading()
        if(res.res.code === 10000 && res.body){
          this.endPicRequired = res.body.endPicRequired;
          this.hasEvaluateTemplate = res.body.hasEvaluateTemplate;
          this.data = res.body.intservOrder || {};
          if(this.prePrice != this.data.totalPrice && this.prePrice && this.come != 'staff' && this.come != 'admin' && this.come != 'manage'){
            util.showToast('服务报价已变更，刷新后按最新价值支付',3000)
            clearTimeout(timer)
          }
          this.prePrice = this.data.totalPrice;
          this.serviceType = this.data.serviceType;
          this.intservWorker = res.body.intservWorker || {}
          this.intservServer = res.body.intservServer || {}
          if(this.data.intservImgItems){
            this.data.intservImgItems.forEach(item=>{
              this.imgs.push(item.imgUrl)
            })
            this.curImgs = this.data.intservImgItems.filter(item=>{return item.type ==1})
            this.sureImgs = this.data.intservImgItems.filter(item=>{return item.type ==2})
          }
          this.intservPriceItems = this.data.intservPriceItems || [];
          // 如果现在状态是0,且是用户,5s刷新一次页面

          if(this.data.status == '0' && this.come != 'staff' && this.come != 'admin' && this.come != 'manage'){
            clearTimeout(timer)
            timer = setTimeout(()=>{
              this.getIntServOrderByOrderId()
            },5000)
          }
        }else{
          util.showToast(res.res.msg)
        }
      })
    },
    cancel(){
      util.showModal('','确定要取消该预约吗?',true,'确定',()=>{
        this.updateIntServOrder('1')
      })
    },
    updateIntServOrder(status){
      let params = {
        id:this.data.id,
        orderId:this.$route.query.id,
        status:status,//取消
        imgs:[]
      }
      if(status === '0'){
        params.payType = '6'
      }
      let header = {}
      if(this.$route.query.marketId || this.data.marketId){
        header.marketId = this.$route.query.marketId || this.data.marketId
      }
      if(this.$route.query.cityId){
        header.cityId = this.$route.query.cityId
      }
      util.showLoading()
      updateIntServOrder(params,header).then(res=>{
        console.log(res)
        util.hideLoading()
        if(res.res.code === 10000){
          util.showToast('操作成功')
          this.getIntServOrderByOrderId()
        }else{
          util.showToast(res.res.msg)
        }
      })
    },
    surePay(){
      util.showModal('','是否确定用户已线下支付?',true,'确定',()=>{
        this.updateIntServOrder('2')
      })
    },
    // peopleType  2是 派单给主管 1 派单给服务员
    dispatch(peopleType){
      let cityId = this.$route.query.cityId || this.data.cityId;
      let serviceType ='';
      if(this.serviceType){
        serviceType = encodeURIComponent(this.serviceType);
      }
      this.$router.push(`/houseDispatch?id=${this.data.id}&orderId=${this.data.orderId}&marketid=${this.data.marketId}&cityId=${cityId}&serviceType=${serviceType}&peopleType=${peopleType}`)
    },
    costEvaluate(val){
      let cityId = this.$route.query.cityId || this.data.cityId;
      // 改价
      if(val == 'changePrice'){
        window.localStorage.setItem('imgs',JSON.stringify(this.curImgs))
        this.$router.push(`/costEvaluate?id=${this.data.id}&orderId=${this.data.orderId}&marketid=${this.data.marketId}&cityId=${cityId}&price=${this.data.totalPrice}&workerId=${this.intservWorker.id}`)
      }else{
        this.$router.push(`/costEvaluate?id=${this.data.id}&orderId=${this.data.orderId}&marketid=${this.data.marketId}&cityId=${cityId}`)
      }
    },
    serviceC(){
      if(this.data.status  == '10' && !this.come){
        this.updateIntServOrder('5')//服务完成
        return;
      }
      if(this.endPicRequired != 1){
        this.updateIntServOrder('10')//服务完成
      }else{
        let cityId = this.$route.query.cityId || this.data.cityId;
        this.$router.push(`/serviceCompletion?id=${this.data.id}&orderId=${this.data.orderId}&marketid=${this.data.marketId}&cityId=${cityId}`)
      }
    },
    toEvaluate () {
      this.$router.push(
        `/evaluate/evaluate?id=${this.data.orderId}&orderId=${this.data.orderId}&referenceName=家政服务&templateType=5&referenceNo=${this.data.orderNo}&marketId=${this.data.marketId}`
      );
    },
    viewEvaluate(){
      this.$router.push(`/evaluate/viewEvaluate?id=${this.data.orderId}`);
    },
    offlinePay(){
      this.updateIntServOrder('0')//线下支付
    },
    pay(){
      // 如果是已过期的状态,先处理为待处理状态
      if(this.data.status == '3'){
        let params = {
          id:this.data.id,
          orderId:this.$route.query.id,
          status:'0',
          imgs:[]
        }
        let header = {}
        if(this.$route.query.marketId || this.data.marketId){
          header.marketId = this.$route.query.marketId || this.data.marketId
        }
        if(this.$route.query.cityId){
          header.cityId = this.$route.query.cityId
        }
        util.showLoading()
        updateIntServOrder(params,header).then(res=>{
          console.log(res)
          util.hideLoading()
          if(res.res.code === 10000){
            this.payFun()
          }
        })
      }else{
        this.payFun()
      }
    },
    payFun(){
      let params = {
        orderNo: this.data.orderNo,
        repairNo: "", // "报修单号",
        bussinessType:"5",//会议室1,活动2,租赁账单3,物业报修4,保洁服务5,送水服务6
        feeCode:"",
        // payType: payType, // "支付类型 0微信，1支付宝, 4万生活, 5,ping++"6.线下支付
        channel: "wx_pub" // 渠道名
      };
      ping(
        params,
        '',
        res => {
          console.log(res);
          this.updateIntServOrder('2')
          this.getIntServOrderByOrderId()
        },
        () => {
          console.log("error")
          this.getIntServOrderByOrderId()
        },
        () => {
          console.log("cancel")
          this.getIntServOrderByOrderId()
        }
      );
    },
  }
};
</script>
<style lang="less" scoped>
@import "../../assets/css/common.less";
.container {
  background: #eee;
}
.progress_box {
  height: 200px;
  background: #fff;
  margin-bottom: 14px;
   .flex();
  flex-wrap: nowrap;
  // overflow-x: scroll;
  // -webkit-overflow-scrolling: touch;
  .progress_item {
    width: 150px;
    flex-shrink: 0;
    .flex();
    flex-direction: column;
    align-items: center;
    position: relative;
    margin-top: 32px;
    &:last-child {
      .line {
        width: 0;
      }
    }
    img {
      display: block;
      width: 36px;
      height: 36px;
      padding: 8px;
      position: relative;
      z-index: 3;
      background: #fff;
    }
    .default_item {
      display: block;
      width: 16px;
      height: 16px;
      border-radius: 100%;
      border: 18px solid #fff;
      background: #eee;
      position: relative;
      z-index: 3;
    }
    .status_cur {
      font-size: 24px;
      color: rgba(51, 51, 51, 1);
      line-height: 34px;
      margin-bottom: 10px;
    }
    .status_primary {
      color: #999;
    }
    .data {
      font-size: 22px;
      color: rgba(153, 153, 153, 1);
      line-height: 26px;
      text-align: center;
    }
    .line {
      position: absolute;
      top: 22px;
      left: 50%;
      height: 4px;
      width: 100%;
      background: #f4f4f4;
      z-index: 2;
    }
    .line_color {
      background: @color17;
    }
  }
}
.scroll_box{
  height:190px;
  width:100%;
  background:#fff;
  margin-bottom: 14px;
}
.progress_box_left {
  height: 200px;
  margin-left: -300px;
  background: #fff;
  margin-bottom: 14px;
   .flex();
  // width: 100vw;
  flex-wrap: nowrap;
  // justify-content: center;
  overflow-x: scroll;
  -webkit-overflow-scrolling: touch;
  .progress_item {
    width: 150px;
    flex-shrink: 0;
    .flex();
    flex-direction: column;
    align-items: center;
    position: relative;
    margin-top: 32px;
    &:last-child {
      .line {
        width: 0;
      }
    }
    img {
      display: block;
      width: 36px;
      height: 36px;
      padding: 8px;
      position: relative;
      z-index: 3;
      background: #fff;
    }
    .default_item {
      display: block;
      width: 16px;
      height: 16px;
      border-radius: 100%;
      border: 18px solid #fff;
      background: #eee;
      position: relative;
      z-index: 3;
    }
    .status_cur {
      font-size: 24px;
      color: rgba(51, 51, 51, 1);
      line-height: 34px;
      margin-bottom: 10px;
    }
    .status_primary {
      color: #999;
    }
    .data {
      font-size: 22px;
      color: rgba(153, 153, 153, 1);
      line-height: 26px;
      text-align: center;
    }
    .line {
      position: absolute;
      top: 22px;
      left: 50%;
      height: 4px;
      width: 100%;
      background: #f4f4f4;
      z-index: 2;
    }
    .line_color {
      background: @color17;
    }
  }
}

.common_module {
  padding: 28px 28px 8px;
  background: #fff;
  margin-bottom: 14px;
  overflow: hidden;
  h2 {
    padding-left: 18px;
    margin-bottom: 28px;
    position: relative;
    height: 44px;
    font-size: 32px;
    font-weight: bold;
    color: rgba(51, 51, 51, 1);
    line-height: 44px;
    &:after {
      position: absolute;
      content: "";
      left: 0;
      top: 10px;
      width: 6px;
      height: 24px;
      background: @color17;
    }
  }
  li {
    .flex();
    align-items: flex-start;
    margin-bottom: 20px;
    .list_left {
      width: 152px;
      line-height: 36px;
      font-size: 26px;
      color: rgba(153, 153, 153, 1);
    }
    .list_right {
      flex: 1;
      line-height: 36px;
      word-break: break-all;
      font-size: 26px;
      color: rgba(51, 51, 51, 1);
      a {
        color: @color17;
        font-size: 26px;
        line-height: 36px;
      }
    }
    .imgs {
      .flex();
      flex: 1;
      img {
        display: block;
        width: 120px;
        height: 120px;
        border-radius: 4px;
        margin-right: 28px;
        margin-bottom: 20px;
      }
    }
  }
}
.footer_h {
  height: 108px;
  width: 100%;
}
.footer_box {
  .btn {
    width: 332px;
    height: 68px;
    border-radius: 4px;
    line-height:68px;
    box-sizing: border-box;
    text-align:center;
    font-size:28px;
    margin:0 10px;
  }
  .btn_left{
    .border(rgba(150, 170, 240, 1));
    background: rgba(243, 245, 253, 1);
    color:@color17;
  }
  .btn_right{
    border:0;
    box-shadow: 0 0 0 #fff;
    background: @color17;
    color:#fff;
  }
  .btn_w{
    width:100%;
  }
  .btn_unclick{
    background:rgba(218,218,218,1);
    color:#fff;
  }
}
.cost_box{
  height:100px;
  padding:0 28px;
  .flex();
  justify-content: space-between;
  align-items: center;
  background:#fff;
  margin-bottom:14px;
  span{
    font-size:28px;
    color:rgba(51,51,51,1);
    &.span_left{
      flex:1;
    }
    &.desc{
      color:#999;
      font-size:24px;
      flex:1;
      margin-left:20px;
    }
    &.price{
      color:@colorfc;
    }
  }
  .change_price{
    font-size:26px;
    color:rgba(23,64,218,1);
    margin-left:20px;
  }
}
.wait_cost{
  background:rgba(255,242,232,1);
  .flex();
  flex-direction: column;
  align-items: center;
  justify-content: center;
  position: fixed;bottom:0;left:0;right:0;
  height:108px;
  text-align:center;
  p{
    font-size:28px;
    color:rgba(51,51,51,1);
    line-height:40px;
    &.desc{
      font-size:24px;
      color:rgba(153,153,153,1);
      line-height:34px;
    }
  }
}
.changePrice_box{
  background:rgba(248,248,248,1);
  margin-bottom: 20px;
  padding:0 32px;
  margin-top:-20px;
  h3{
    height:88px;
    line-height: 88px;
    font-size:28px;
    color:rgba(51,51,51,1);
    border-bottom:2px solid #EAEAEA;
  }
  .change_item{
    padding:20px 0 26px;
    .flex(column);
    justify-content: space-between;
    border-bottom:1px solid #eaeaea;
    &:last-child{
      border:0;
    }
    .change_item_top{
      .flex();
      width:100%;
      justify-content: space-between;
      p{
        font-size:26px;
        color:rgba(153,153,153,1);
        line-height:36px;
      }
    }
    .change_item_bottom{
      margin-top:16px;
      .flex();
      width:100%;
      justify-content: space-between;
      p{
        font-size:26px;
        color:rgba(153,153,153,1);
        line-height:36px;
        &.right_price{
          color:#333;
        }
      }
    }
  }
}
</style>
